import {useCallback, useEffect} from "react";
import {generatePositions, validateMultiplePositions} from "../../utils/gameUtils/putItemOnGrid";
import {DIMENSION_GRID} from "../../contants";
import {dataStorage} from "../../utils/StorageService";
import {useYandexSdk} from "../../provider/yandex/yandexSdk";
import {DragItemType, GridItemType} from "../../types";
import {eventEmitter} from "../../EventEmitter";

interface Props {
    dragItems: DragItemType[];
    gridData: GridItemType[][];
    score: number;
    totalScore: number;
    setGameOver: (p: boolean) => void;
    setTotalScore: (p: number) => void;
}

export const useGameOverEffect = ({dragItems, gridData, setGameOver, setTotalScore, totalScore, score}: Props) => {
    const {lb, player, handleRequestLeaderBord} = useYandexSdk()

    const handleGameOver = useCallback(() => {
        setGameOver(true);
        if ((totalScore || 0) < score) {
            setTotalScore(score);
            dataStorage.setItem({
                total_score_data: score,
                grid_data: gridData,
                tools_panel: dragItems
            });

            lb.setLeaderboardScore(dataStorage.isBombMode ? 'totalScoreBombData' : 'totalScoreData', score)

            handleRequestLeaderBord(player);
        }
    }, [totalScore, score, gridData, dragItems, setTotalScore, setGameOver, player, lb])

    useEffect(() => {
        const handleDataUpdate = () => {
            handleGameOver();
        };

        eventEmitter.on('game_over_by_bomb', handleDataUpdate);

        return () => {
            eventEmitter.off('game_over_by_bomb', handleDataUpdate);
        };
    }, [handleGameOver]);

    useEffect(() => {
        // if result === 0 => game over // show the window with score

        setTimeout(() => {
            const gameEnd = dragItems.every((item) => {
                const pos = generatePositions(DIMENSION_GRID);
                const results = validateMultiplePositions(pos, gridData, item);

                return !results.length;
            })

            if (gameEnd) {
                handleGameOver();
            }
        }, 1000);
    }, [dragItems, totalScore, score, player])
}
